<script setup lang="ts">
const props = defineProps<{
  modelValue: boolean;
}>();

const emits = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const { t } = useI18n();

const value = computed({
  get: () => {
    return props.modelValue;
  },
  set: (newValue: boolean) => {
    emits("update:modelValue", newValue);
  },
});

const options = computed(() => [
  {
    value: false,
    label: t("SV.LIT_OneColumnLayout"),
    icon: "fa-align-justify",
    key: "one-col",
  },
  {
    value: true,
    label: t("S.LIT_TwoColumnLayout"),
    icon: "fa-line-columns",
    key: "two-col",
  },
]);
</script>

<template>
  <ToolbarButtonGroup
    :title="$t('SV.LIT_Columns')"
    class="hidden xl:block"
  >
    <ToolbarButton
      v-for="o of options"
      :key="o.key"
      :icon="o.icon"
      :label="o.label"
      @click="value = o.value"
      :active="value === o.value"
    />
  </ToolbarButtonGroup>
  <ToolbarButtonDropdown
    :label="$t('SV.LIT_Columns')"
    icon="fa-line-columns"
    class="xl:hidden"
  >
    <ToolbarButtonDropdownHeader>{{
      $t("SV.LIT_Columns")
    }}</ToolbarButtonDropdownHeader>
    <ToolbarButtonDropdownItem
      v-for="o of options"
      :key="o.key"
      :icon="o.icon"
      @click="value = o.value"
      :active="value === o.value"
    >
      {{ o.label }}
    </ToolbarButtonDropdownItem>
  </ToolbarButtonDropdown>
</template>

<style scoped lang="postcss"></style>
